export default {
  form: {
    header: {
      label: 'Intestazione',
      placeholder: 'Intestazione',
    },
    sub_header: {
      label: 'Sottotitolo',
      placeholder: 'Sottotitolo',
    },
    qr_code_header: {
      label: 'Titolo del riquadro',
      placeholder: 'Titolo del riquadro',
    },
    qr_code_description: {
      label: 'Descrizione del riquadro',
      placeholder: 'Descrizione del riquadro',
    },
    footer: {
      label: 'Testo del piè di pagina',
      placeholder: 'Inserisci testo del piè di pagina',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleziona URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Colore primario',
    },
    background_color: {
      label: 'Colore di sfondo',
    },
    cover_image: {
      label: 'Immagine di copertina',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Impossibile caricare il volantino',
  },
};
